import Modal from '@components/modal'
import { FC } from 'react'
import { StyleAlertDescription, StyleAlertTitle } from './style'
import Column from '@components/column'
import Row from '@components/row'
import Button from '@components/button'
interface AlertProps {
  title?: string
  description?: string
  onClickOk?: () => void
  onClickClose?: () => void
  visible?: boolean
  loading?: boolean
}
const Alert: FC<AlertProps> = ({
  title = 'Delete Confirmation',
  description = 'Are you sure you want to delete ? ',
  visible = false,
  onClickClose,
  onClickOk,
  loading = false,
}) => {
  return (
    <Modal
      visible={visible}
      onClose={() => {
        !!onClickClose && onClickClose()
      }}
    >
      <StyleAlertTitle>{title}</StyleAlertTitle>
      <StyleAlertDescription>{description}</StyleAlertDescription>
      <Column alignItems="flex-end" styleColumn="margin-top:20px">
        <Row colGap={10} justifyContent="space-between" styleRow="width:100%;">
          <Button
            onClick={onClickClose}
            outline
            bg="danger"
            title="Cancel"
            styleButtonWrapper="width:48%"
            styleButton="width:100%"
            height={40}
          />
          <Button
            onClick={onClickOk}
            title="Yes"
            loading={loading}
            styleButtonWrapper="width:48%"
            styleButton="width:100%"
            height={40}
          />
        </Row>
      </Column>
    </Modal>
  )
}

export default Alert
